module.exports = __webpack_public_path__ + "static/media/img3.051a2fe8.jpg";